import PropTypes from 'prop-types';
import React from 'react';
import { Translate } from 'react-localize-redux';
import { Button } from '../../../components/widgets';
import PermissionsWrapper from '../../../containers/PermissionsWrapper';
import AddAppSiteButton from '../AddAppSiteButton';
import AppSitesTable from '../AppSitesTable';
import PageHeader from '../PageHeader';
import { partnerShape } from '../types';
import baseCss from './BasePartnerAppSitesSummary.css';
import partnerCss from './UserConfigurationAppSitesSummary.css';

const css = { ...baseCss, ...partnerCss };

export const USER_CONFIGURATION_PARTNER_NAMES = ['twitter'];

const UserConfigurationAppSitesSummary = ({
    partner,
    appFilter = '',
    agencyFilter = '',
    onAppSiteForPartner = () => {},
    onUserConfigurationForPartner = () => {},
}) => {
    const onUsersConfigurationClick = () => onUserConfigurationForPartner(partner);

    return (
        <div className={css.appSitesSummary}>
            <PageHeader partner={partner} />
            <div className={css.actions}>
                <PermissionsWrapper write requiredSingleAccessLevel>
                    <AddAppSiteButton partner={partner} onAddAppSite={onAppSiteForPartner} />
                </PermissionsWrapper>
                <Button
                    type="secondary"
                    className={css.userConfiguration}
                    Icon="settings"
                    iconClass={css.userConfigurationIcon}
                    onClick={onUsersConfigurationClick}
                >
                    <Translate id="STATIC.PAGES.PARTNER_CONFIGURATION.USER_CONFIGURATION" />
                </Button>
            </div>
            <AppSitesTable
                appFilter={appFilter}
                agencyFilter={agencyFilter}
                partner={partner}
                onAppSiteForPartner={onAppSiteForPartner}
            />
        </div>
    );
};

UserConfigurationAppSitesSummary.propTypes = {
    partner: partnerShape.isRequired,
    appFilter: PropTypes.string,
    agencyFilter: PropTypes.string,
    onAppSiteForPartner: PropTypes.func,
    onUserConfigurationForPartner: PropTypes.func,
};

export default UserConfigurationAppSitesSummary;
